(function () {
  'use strict';

  var SESSION_KEY = 'mobileSearchQuery';
  var MOBILE_BREAKPOINT = 767;
  var OPEN_CLASS = 'is-open';
  var BODY_OPEN_CLASS = 'mobile-search-open';
  var DEBOUNCE_MS = 50;
  var MIN_QUERY_LENGTH = 1;
  var SUGGESTION_LIMIT = 4;
  var COLLECTION_LIMIT = 6;
  var PRODUCT_LIMIT = 6;
  var PAGE_LIMIT = 3;
  var DYM_LIMIT = 2;
  var FETCH_TIMEOUT_MS = 5000;
  var RECENT_SEARCHES_KEY = 'boostPFSRecentSearches';
  var RECENT_PRODUCTS_KEY = 'mobileSearchRecentProducts';
  var RECENT_COLLECTIONS_KEY = 'mobileSearchRecentCollections';
  var BOOST_ANALYTICS_KEY = 'boostPFSAnalytics';
  var BOOST_CLICKED_PRODUCT_KEY = 'boostPFSClickedProduct';
  var BOOST_REQUEST_IDS_KEY = 'boostPFSRequestIds';
  var BOOST_SESSION_KEY = 'boostPFSSessionId';
  var OVERLAY_ANALYTICS_KEY = 'mobileSearchOverlayAnalytics';
  var RECENT_SEARCH_LIMIT = 3;
  var RECENT_SEARCH_STORE_LIMIT = 10;
  var RECENT_ENTITY_LIMIT = 3;
  var RECENT_ENTITY_STORE_LIMIT = 10;
  var OVERLAY_ANALYTICS_LIMIT = 50;
  var BOOST_ACTION_SUGGEST = 'suggest';
  var BOOST_ACTION_SEARCH = 'search';
  var BOOST_USER_ACTION_VIEW_PRODUCT = 'view_product';
  var OVERLAY_USER_ACTION_VIEW_COLLECTION = 'view_collection';
  var OVERLAY_USER_ACTION_VIEW_SEARCH_RESULTS = 'view_search_results';
  var BOOST_SUGGEST_EVENT_TYPE = 'suggest';

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  // --- Boost suggestion fetch ---
  // Boost's suggestion endpoint uses JSONP: it responds by calling
  // window.BoostPFSInstantSearchCallback(data). We temporarily replace
  // that global with our own handler for the duration of our request,
  // then restore whatever was there before.

  function getSuggestionUrl() {
    return (
      window.boostPFSConfig &&
      window.boostPFSConfig.api &&
      window.boostPFSConfig.api.suggestionUrl
    ) || 'https://services.mybcapps.com/bc-sf-filter/search/suggest';
  }

  function getShopDomain() {
    return (
      window.boostPFSConfig &&
      window.boostPFSConfig.shop &&
      window.boostPFSConfig.shop.domain
    ) || window.location.hostname;
  }

  function formatMoney(dollars) {
    if (!dollars && dollars !== 0) return '';
    // Boost suggestion JSONP returns price_min / compare_at_price_min in dollars (not cents).
    // Shopify.formatMoney expects cents, so multiply back up.
    var fmt =
      window.boostPFSConfig &&
      window.boostPFSConfig.shop &&
      window.boostPFSConfig.shop.money_format;
    if (fmt && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(Math.round(Number(dollars) * 100), fmt);
    }
    // Fallback: plain dollar formatting
    return '$' + parseFloat(dollars || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getStoredJson(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return null;
    }
  }

  function setStoredJson(key, value) {
    try {
      if (value != null) {
        localStorage.setItem(key, JSON.stringify(value));
      } else {
        localStorage.setItem(key, '');
      }
    } catch (e) {}
  }

  function generateUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function getBoostSessionId() {
    if (window.Analytics && typeof window.Analytics.getSessionId === 'function') {
      return window.Analytics.getSessionId();
    }

    var sessionId = getStoredJson(BOOST_SESSION_KEY);
    if (sessionId) return sessionId;

    sessionId = generateUuid();
    setStoredJson(BOOST_SESSION_KEY, sessionId);
    return sessionId;
  }

  // --- MobileSearchOverlayController ---

  function MobileSearchOverlayController() {
    this.overlay = document.getElementById('mobile-search-overlay');
    this.input = document.getElementById('mobile-search-overlay-input');
    this.results = document.getElementById('mobile-search-overlay-results');
    this.form = this.input ? this.input.closest('form') : null;
    this.clearButton = this.overlay ? this.overlay.querySelector('[data-mobile-search-clear]') : null;
    this.triggers = Array.from(document.querySelectorAll('[data-mobile-search-trigger]'));
    this.closeButtons = Array.from(document.querySelectorAll('[data-mobile-search-close]'));
    this.scroller = document.querySelector('.scroller');
    this._isOpen = false;
    this._activeTrigger = null;
    this._boundOnKeydown = this._onKeydown.bind(this);

    // Suggestion fetch state
    this._debounceTimer = null;
    this._pendingRequestId = 0;
    this._fetchTimeoutTimer = null;
    this._currentQuery = '';
    this._onViewportResize = null;

    if (!this.overlay || !this.input) return;
    this._bindEvents();
  }

  MobileSearchOverlayController.prototype._bindEvents = function () {
    var self = this;
    var blurThreshold = 8;

    this.triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        self._activeTrigger = trigger;
        self.open();
      });
    });

    this.closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.close();
      });
    });

    if (this.clearButton) {
      this.clearButton.addEventListener('click', function () {
        self._clearInput();
      });
    }

    // Debounced input handler: persists query to sessionStorage and fires suggestion fetch
    this.input.addEventListener('input', function () {
      var q = self.input.value;
      self._syncHeaderControls();
      // Always persist and fire the public event
      window.dispatchEvent(new CustomEvent('mobile-search:query', { detail: { query: q } }));
      // Debounce the fetch
      clearTimeout(self._debounceTimer);
      self._debounceTimer = setTimeout(function () {
        self._onQueryChange(q);
      }, DEBOUNCE_MS);
    });

    if (this.form) {
      this.form.addEventListener('submit', function () {
        self._trackManualSubmit();
        getBoostSessionId();
        self._saveActiveQuery(self.input.value);
        self._saveRecentSearch(self.input.value);
      });
    }

    // Empty/default overlay state can hide the results scroller entirely.
    // Listen for a real touch-scroll gesture on the overlay shell too so the
    // keyboard still dismisses when the user drags the open overlay.
    if (this.overlay) {
      var _overlayTouchY = null;
      this.overlay.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        _overlayTouchY = event.touches[0].clientY;
      }, { passive: true });
      this.overlay.addEventListener('touchmove', function (event) {
        if (
          !self._isOpen ||
          !self.input ||
          document.activeElement !== self.input ||
          _overlayTouchY === null ||
          !event.touches ||
          !event.touches.length
        ) {
          return;
        }

        if (Math.abs(event.touches[0].clientY - _overlayTouchY) > blurThreshold) {
          self.input.blur();
          _overlayTouchY = event.touches[0].clientY;
        }
      }, { passive: true });
    }

    if (this.results) {
      // Dismiss keyboard when the user scrolls results — lets them see more content.
      // Uses a touchstart anchor + 8px threshold to ignore accidental micro-movements.
      var _scrollAnchor = 0;
      this.results.addEventListener('touchstart', function () {
        _scrollAnchor = self.results.scrollTop;
      }, { passive: true });
      this.results.addEventListener('scroll', function () {
        if (
          self._isOpen &&
          self.input &&
          document.activeElement === self.input &&
          Math.abs(self.results.scrollTop - _scrollAnchor) > blurThreshold
        ) {
          self.input.blur();
        }
      }, { passive: true });

      this.results.addEventListener('click', function (e) {
        var link = e.target.closest('a');
        if (!link || !self.results.contains(link)) return;

        var analyticsPayload = self._parseJsonAttr(link.getAttribute('data-mso-analytics'));
        if (analyticsPayload) {
          self._trackOverlayLinkInteraction(analyticsPayload);
        }

        var searchTerm = link.getAttribute('data-mso-save-search');
        if (searchTerm) {
          self._saveActiveQuery(searchTerm);
          self._saveRecentSearch(searchTerm);
          return;
        }

        var recentProduct = link.getAttribute('data-mso-recent-product');
        if (recentProduct) {
          self._clearActiveQuery();
          self._saveRecentProduct(recentProduct);
          return;
        }

        var recentCollection = link.getAttribute('data-mso-recent-collection');
        if (recentCollection) {
          self._clearActiveQuery();
          self._saveRecentCollection(recentCollection);
        }
      });
    }
  };

  MobileSearchOverlayController.prototype._onQueryChange = function (q) {
    q = (q || '').trim();
    if (q.length < MIN_QUERY_LENGTH) {
      this._showRecentSearches();
      return;
    }
    this._fetchSuggestions(q);
  };

  // --- JSONP suggestion fetch ---

  MobileSearchOverlayController.prototype._fetchSuggestions = function (q) {
    var self = this;
    var requestId = ++this._pendingRequestId;
    this._currentQuery = q;

    // Unique callback name per request — the Boost API reads the `callback` param
    // and wraps its JSON payload with that function name, so we receive the response
    // in our own global without touching Boost's callback pipeline at all.
    var callbackName = '__msoSuggest_' + requestId;

    this._showLoading();

    // Install the one-shot JSONP callback before injecting the script
    window[callbackName] = function (data) {
      delete window[callbackName];
      clearTimeout(self._fetchTimeoutTimer);
      if (requestId !== self._pendingRequestId) return;
      self._handleResponse(data, q);
    };

    // Build query string — callback param tells the API which global to call
    var params = [];
    params.push('q=' + encodeURIComponent(q));
    params.push('shop=' + encodeURIComponent(getShopDomain()));
    params.push('suggestion_limit=' + SUGGESTION_LIMIT);
    params.push('collection_limit=' + COLLECTION_LIMIT);
    params.push('product_limit=' + PRODUCT_LIMIT);
    params.push('page_limit=' + PAGE_LIMIT);
    params.push('dym_limit=' + DYM_LIMIT);
    params.push('fuzzy=false');
    params.push('t=' + Date.now());
    params.push('sid=' + encodeURIComponent(getBoostSessionId()));
    params.push('event_type=' + BOOST_SUGGEST_EVENT_TYPE);
    params.push('callback=' + callbackName);

    // Locale param — only if multi-locale is configured
    var cfg = window.boostPFSConfig;
    if (cfg && cfg.general && cfg.general.current_locale &&
        cfg.general.published_locales &&
        Object.keys(cfg.general.published_locales).length > 1) {
      params.push('locale=' + encodeURIComponent(cfg.general.current_locale));
    }

    var url = getSuggestionUrl() + '?' + params.join('&');

    // Inject the JSONP script tag
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = url;
    script.onerror = function () {
      if (script.parentNode) script.parentNode.removeChild(script);
      delete window[callbackName];
      clearTimeout(self._fetchTimeoutTimer);
      if (requestId === self._pendingRequestId) {
        self._clearResults();
      }
    };
    script.onload = function () {
      if (script.parentNode) script.parentNode.removeChild(script);
    };

    // Safety timeout — clean up if the callback never fires
    clearTimeout(this._fetchTimeoutTimer);
    this._fetchTimeoutTimer = setTimeout(function () {
      delete window[callbackName];
      if (requestId === self._pendingRequestId) {
        self._clearResults();
      }
    }, FETCH_TIMEOUT_MS);

    document.head.appendChild(script);
  };

  MobileSearchOverlayController.prototype._handleResponse = function (data, q) {
    this._recordBoostSuggestRequest(data);

    var suggestions = (data && Array.isArray(data.suggestions)) ? data.suggestions : [];
    var collections = (data && Array.isArray(data.collections)) ? data.collections : [];
    var products = (data && Array.isArray(data.products)) ? data.products : [];
    var dym = (data && Array.isArray(data.did_you_mean)) ? data.did_you_mean : [];

    if (!suggestions.length && !collections.length && !products.length && !dym.length) {
      this._showEmpty(q);
      return;
    }

    this._renderResults(suggestions, collections, products, q, dym);
  };

  MobileSearchOverlayController.prototype._recordBoostSuggestRequest = function (data) {
    var requestIds = getStoredJson(BOOST_REQUEST_IDS_KEY) || {};

    requestIds[BOOST_ACTION_SUGGEST] = {
      rid: data && data.meta ? data.meta.rid : null,
      data: data || null
    };

    setStoredJson(BOOST_REQUEST_IDS_KEY, requestIds);
  };

  MobileSearchOverlayController.prototype._buildOverlayQueryString = function (options) {
    options = options || {};
    var parts = [];
    var query = typeof options.query === 'string' ? options.query.trim() : '';
    var handle = typeof options.handle === 'string' ? options.handle.trim() : '';
    var destinationType =
      typeof options.destinationType === 'string' ? options.destinationType.trim() : '';

    if (query) {
      parts.push('q=' + encodeURIComponent(query));
    }

    if (destinationType === 'collection' && handle) {
      parts.push('collection=' + encodeURIComponent(handle));
    }

    if (!parts.length && handle) {
      parts.push('handle=' + encodeURIComponent(handle));
    }

    return parts.join('&');
  };

  MobileSearchOverlayController.prototype._buildOverlayAnalyticsData = function (options) {
    options = options || {};
    var action = typeof options.action === 'string' ? options.action : BOOST_ACTION_SUGGEST;
    var requestAction =
      typeof options.requestAction === 'string' ? options.requestAction : action;
    var query = typeof options.query === 'string' ? options.query.trim() : '';
    var productId = options.productId != null ? String(options.productId).trim() : '';
    var handle = typeof options.handle === 'string' ? options.handle.trim() : '';
    var title = typeof options.title === 'string' ? options.title.trim() : '';
    var term = typeof options.term === 'string' ? options.term.trim() : '';
    var url = typeof options.url === 'string' ? options.url.trim() : '';
    var destinationType =
      typeof options.destinationType === 'string' ? options.destinationType.trim() : '';
    var requestIds = getStoredJson(BOOST_REQUEST_IDS_KEY) || {};

    return {
      tid: getShopDomain(),
      sid: getBoostSessionId(),
      ct: '',
      pid: productId || '',
      handle: handle || '',
      title: title || '',
      term: term || '',
      q: query || '',
      qs: this._buildOverlayQueryString({
        query: query,
        handle: handle,
        destinationType: destinationType
      }),
      t: new Date().toISOString(),
      u: options.userAction || OVERLAY_USER_ACTION_VIEW_SEARCH_RESULTS,
      a: action,
      source: options.source || '',
      destination_type: destinationType || '',
      destination_url: url || '',
      r: document.referrer,
      rid: options.rid || (requestIds[requestAction] && requestIds[requestAction].rid) || null
    };
  };

  MobileSearchOverlayController.prototype._saveOverlayAnalytics = function (data) {
    if (!data || typeof data !== 'object') return;

    var rows = getStoredJson(OVERLAY_ANALYTICS_KEY);
    if (!Array.isArray(rows)) {
      rows = [];
    }

    rows.push(data);
    if (rows.length > OVERLAY_ANALYTICS_LIMIT) {
      rows = rows.slice(rows.length - OVERLAY_ANALYTICS_LIMIT);
    }

    setStoredJson(OVERLAY_ANALYTICS_KEY, rows);
  };

  MobileSearchOverlayController.prototype._trackOverlayInteraction = function (options) {
    var data = this._buildOverlayAnalyticsData(options);
    this._saveOverlayAnalytics(data);
    return data;
  };

  MobileSearchOverlayController.prototype._trackBoostProductClick = function (options) {
    options = options || {};
    var productId = options.productId != null ? String(options.productId).trim() : '';
    if (!productId) return null;

    var boostData = this._buildOverlayAnalyticsData({
      action: options.action || BOOST_ACTION_SUGGEST,
      destinationType: 'product',
      handle: options.handle || '',
      productId: productId,
      query: options.query || '',
      rid: options.rid || null,
      source: options.source || 'product_suggestion',
      term: options.term || '',
      title: options.title || '',
      url: options.url || '',
      userAction: BOOST_USER_ACTION_VIEW_PRODUCT
    });

    var clickedProducts = getStoredJson(BOOST_CLICKED_PRODUCT_KEY) || {};
    var analyticsRows = getStoredJson(BOOST_ANALYTICS_KEY);

    if (!Array.isArray(analyticsRows)) {
      analyticsRows = [];
    }

    clickedProducts[productId] = {
      tid: boostData.tid,
      ct: boostData.ct,
      pid: boostData.pid,
      t: boostData.t,
      u: boostData.u,
      a: boostData.a,
      qs: boostData.qs,
      r: boostData.r,
      rid: boostData.rid
    };
    setStoredJson(BOOST_CLICKED_PRODUCT_KEY, clickedProducts);

    analyticsRows = analyticsRows.filter(function (row) {
      return !row || String(row.pid) !== productId;
    });
    analyticsRows.push(clickedProducts[productId]);
    setStoredJson(BOOST_ANALYTICS_KEY, analyticsRows);

    this._saveOverlayAnalytics(boostData);
    return boostData;
  };

  MobileSearchOverlayController.prototype._trackOverlayLinkInteraction = function (payload) {
    if (!payload || typeof payload !== 'object') return null;

    if (payload.productId) {
      return this._trackBoostProductClick(payload);
    }

    return this._trackOverlayInteraction({
      action: payload.action || BOOST_ACTION_SEARCH,
      destinationType: payload.destinationType || 'search',
      handle: payload.handle || '',
      query: payload.query || '',
      rid: payload.rid || null,
      source: payload.source || '',
      term: payload.term || '',
      title: payload.title || '',
      url: payload.url || '',
      userAction: payload.userAction || OVERLAY_USER_ACTION_VIEW_SEARCH_RESULTS
    });
  };

  MobileSearchOverlayController.prototype._trackManualSubmit = function () {
    var query = this.input && typeof this.input.value === 'string' ? this.input.value.trim() : '';
    if (!query) return;

    this._trackOverlayInteraction({
      action: BOOST_ACTION_SEARCH,
      destinationType: 'search',
      query: query,
      rid: null,
      requestAction: BOOST_ACTION_SUGGEST,
      source: 'manual_submit',
      term: query,
      url: '/search?q=' + encodeURIComponent(query),
      userAction: OVERLAY_USER_ACTION_VIEW_SEARCH_RESULTS
    });
  };

  MobileSearchOverlayController.prototype._trackBoostProductSuggestionClick = function (productId) {
    productId = String(productId || '').trim();
    if (!productId) return;

    return this._trackBoostProductClick({
      action: BOOST_ACTION_SUGGEST,
      destinationType: 'product',
      productId: productId,
      query: (this._currentQuery || this.input.value || '').trim(),
      source: 'product_suggestion',
      userAction: BOOST_USER_ACTION_VIEW_PRODUCT
    });
  };

  // --- Render helpers ---

  MobileSearchOverlayController.prototype._showLoading = function () {
    if (!this.results) return;
    this.results.innerHTML = '<div class="mso-results__loading" aria-hidden="true">' +
      '<span class="mso-results__loading-dot"></span>' +
      '<span class="mso-results__loading-dot"></span>' +
      '<span class="mso-results__loading-dot"></span>' +
      '</div>';
    this.results.removeAttribute('hidden');
  };

  MobileSearchOverlayController.prototype._showEmpty = function (q) {
    if (!this.results) return;
    var escaped = this._escapeHtml(q);
    this.results.innerHTML = '<div class="mso-results__empty">' +
      '<p>No results for \u201c' + escaped + '\u201d</p>' +
      '</div>';
    this.results.removeAttribute('hidden');
  };

  MobileSearchOverlayController.prototype._clearResults = function () {
    this._pendingRequestId++;
    clearTimeout(this._debounceTimer);
    clearTimeout(this._fetchTimeoutTimer);
    this._currentQuery = '';
    if (!this.results) return;
    this.results.innerHTML = '';
    this.results.setAttribute('hidden', '');
  };

  MobileSearchOverlayController.prototype._getRecentSearchLimit = function () {
    var recent = window.boostPFSConfig &&
      window.boostPFSConfig.settings &&
      window.boostPFSConfig.settings.search &&
      window.boostPFSConfig.settings.search.searchBoxOnclick &&
      window.boostPFSConfig.settings.search.searchBoxOnclick.recentSearch;
    var limit = recent && Number(recent.number);
    return limit > 0 ? limit : RECENT_SEARCH_LIMIT;
  };

  MobileSearchOverlayController.prototype._isRecentSearchEnabled = function () {
    var recent = window.boostPFSConfig &&
      window.boostPFSConfig.settings &&
      window.boostPFSConfig.settings.search &&
      window.boostPFSConfig.settings.search.searchBoxOnclick &&
      window.boostPFSConfig.settings.search.searchBoxOnclick.recentSearch;

    // If Boost explicitly disables recent searches, mirror that. If the setting
    // is unavailable, allow stored Boost history to render in this theme overlay.
    if (recent && (
      recent.status === false ||
      recent.status === 0 ||
      recent.status === 'false' ||
      recent.status === 'inactive'
    )) {
      return false;
    }
    return true;
  };

  MobileSearchOverlayController.prototype._getRecentSearches = function (all) {
    var stored = [];
    try {
      stored = JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY));
    } catch (e) {
      stored = [];
    }

    if (!Array.isArray(stored)) {
      stored = [];
    }

    var cleaned = [];
    for (var i = 0; i < stored.length; i++) {
      if (typeof stored[i] !== 'string') continue;
      var term = stored[i].trim();
      if (!term) continue;
      cleaned.push(term);
    }

    try {
      if (JSON.stringify(cleaned) !== JSON.stringify(stored)) {
        localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(cleaned));
      }
    } catch (e2) {}

    return all ? cleaned : cleaned.slice(0, this._getRecentSearchLimit());
  };

  MobileSearchOverlayController.prototype._saveRecentSearch = function (term) {
    if (typeof term !== 'string') return;
    term = term.trim();
    if (!term) return;

    var recent = this._getRecentSearches(true);
    var existingIndex = recent.indexOf(term);
    if (existingIndex >= 0) {
      recent.splice(existingIndex, 1);
    }
    recent.unshift(term);
    recent = recent.slice(0, RECENT_SEARCH_STORE_LIMIT);

    try {
      localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(recent));
    } catch (e) {}
  };

  MobileSearchOverlayController.prototype._saveActiveQuery = function (term) {
    if (typeof term !== 'string') return;
    term = term.trim();
    if (!term) return;

    try {
      sessionStorage.setItem(SESSION_KEY, term);
    } catch (e) {}
  };

  MobileSearchOverlayController.prototype._clearActiveQuery = function () {
    try {
      sessionStorage.removeItem(SESSION_KEY);
    } catch (e) {}
  };

  MobileSearchOverlayController.prototype._clearInput = function () {
    if (!this.input) return;
    if (!this.input.value) {
      this._syncHeaderControls();
      this.input.focus();
      return;
    }
    this.input.value = '';
    this._clearActiveQuery();
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.focus();
  };

  MobileSearchOverlayController.prototype._syncHeaderControls = function () {
    if (!this.clearButton || !this.input) return;
    var hasValue = this.input.value.trim().length > 0;
    this.clearButton.classList.toggle('is-visible', hasValue);
    this.clearButton.disabled = !hasValue;
    this.clearButton.setAttribute('aria-hidden', hasValue ? 'false' : 'true');
  };

  MobileSearchOverlayController.prototype._parseJsonAttr = function (value) {
    if (!value || typeof value !== 'string') return null;
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  };

  MobileSearchOverlayController.prototype._getRecentEntities = function (key, all) {
    var stored = [];
    try {
      stored = JSON.parse(localStorage.getItem(key));
    } catch (e) {
      stored = [];
    }

    if (!Array.isArray(stored)) {
      stored = [];
    }

    var cleaned = [];
    for (var i = 0; i < stored.length; i++) {
      var item = stored[i];
      if (!item || typeof item !== 'object') continue;
      var handle = typeof item.handle === 'string' ? item.handle.trim() : '';
      var url = typeof item.url === 'string' ? item.url.trim() : '';
      var title = typeof item.title === 'string' ? item.title.trim() : '';
      if ((!handle && !url) || !title) continue;

      cleaned.push({
        id: item.id != null ? String(item.id).trim() : '',
        handle: handle,
        title: title,
        url: url,
        image: typeof item.image === 'string' ? item.image.trim() : '',
        vendor: typeof item.vendor === 'string' ? item.vendor.trim() : '',
        sku: typeof item.sku === 'string' ? item.sku.trim() : ''
      });
    }

    try {
      if (JSON.stringify(cleaned) !== JSON.stringify(stored)) {
        localStorage.setItem(key, JSON.stringify(cleaned));
      }
    } catch (e2) {}

    return all ? cleaned : cleaned.slice(0, RECENT_ENTITY_LIMIT);
  };

  MobileSearchOverlayController.prototype._saveRecentEntity = function (key, item) {
    if (!item || typeof item !== 'object') return;

    var handle = typeof item.handle === 'string' ? item.handle.trim() : '';
    var url = typeof item.url === 'string' ? item.url.trim() : '';
    var title = typeof item.title === 'string' ? item.title.trim() : '';
    if ((!handle && !url) || !title) return;

    var recent = this._getRecentEntities(key, true);
    var identity = handle || url;
    for (var i = recent.length - 1; i >= 0; i--) {
      if ((recent[i].handle || recent[i].url) === identity) {
        recent.splice(i, 1);
      }
    }

    recent.unshift({
      id: item.id != null ? String(item.id).trim() : '',
      handle: handle,
      title: title,
      url: url,
      image: typeof item.image === 'string' ? item.image.trim() : '',
      vendor: typeof item.vendor === 'string' ? item.vendor.trim() : '',
      sku: typeof item.sku === 'string' ? item.sku.trim() : ''
    });
    recent = recent.slice(0, RECENT_ENTITY_STORE_LIMIT);

    try {
      localStorage.setItem(key, JSON.stringify(recent));
    } catch (e) {}
  };

  MobileSearchOverlayController.prototype._getRecentProducts = function (all) {
    return this._getRecentEntities(RECENT_PRODUCTS_KEY, all);
  };

  MobileSearchOverlayController.prototype._saveRecentProduct = function (payload) {
    this._saveRecentEntity(RECENT_PRODUCTS_KEY, this._parseJsonAttr(payload));
  };

  MobileSearchOverlayController.prototype._getRecentCollections = function (all) {
    return this._getRecentEntities(RECENT_COLLECTIONS_KEY, all);
  };

  MobileSearchOverlayController.prototype._saveRecentCollection = function (payload) {
    this._saveRecentEntity(RECENT_COLLECTIONS_KEY, this._parseJsonAttr(payload));
  };

  MobileSearchOverlayController.prototype._renderRecentSearches = function () {
    if (!this._isRecentSearchEnabled()) return '';

    var recent = this._getRecentSearches(false);
    if (!recent.length) return '';

    var html = '<section class="mso-results__section mso-results__section--recent-searches" aria-label="Recent searches">' +
      '<div class="mso-results__section-title">Recent searches</div>' +
      '<div class="mso-results__section-body">' +
      '<ul class="mso-results__list" role="list">';

    for (var i = 0; i < recent.length; i++) {
      var term = recent[i];
      var recentSearchAnalytics = {
        action: BOOST_ACTION_SEARCH,
        destinationType: 'search',
        query: term,
        source: 'recent_search',
        term: term,
        url: '/search?q=' + encodeURIComponent(term),
        userAction: OVERLAY_USER_ACTION_VIEW_SEARCH_RESULTS
      };
      html += '<li class="mso-results__item mso-results__item--recent">' +
        '<a href="/search?q=' + encodeURIComponent(term) + '" class="mso-results__recent-link" data-mso-save-search="' + this._escapeAttr(term) + '" data-mso-analytics="' + this._escapeAttr(JSON.stringify(recentSearchAnalytics)) + '">' +
        '<svg class="mso-results__recent-icon" aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 18 18" fill="none">' +
        '<path d="M9 2a7 7 0 107 7h-1.4A5.6 5.6 0 119 3.4a5.58 5.58 0 014.04 1.72H10.8v1.4h4.9V1.62h-1.4v2.4A6.97 6.97 0 009 2zm-.7 3.5v4.03l3.36 2.02.72-1.2L9.7 8.74V5.5H8.3z" fill="currentColor"/>' +
        '</svg>' +
        '<span>' + this._escapeHtml(term) + '</span>' +
        '</a>' +
        '</li>';
    }

    html += '</ul></div></section>';
    return html;
  };

  MobileSearchOverlayController.prototype._renderRecentProducts = function () {
    var products = this._getRecentProducts(false);
    if (!products.length) return '';

    var html = '<section class="mso-results__section mso-results__section--recent-products" aria-label="Recent products">' +
      '<div class="mso-results__section-title">Recent products</div>' +
      '<div class="mso-results__section-body">' +
      '<ul class="mso-results__list" role="list">';

    for (var i = 0; i < products.length; i++) {
      var product = products[i];
      var recentProductAnalytics = {
        action: BOOST_ACTION_SUGGEST,
        destinationType: 'product',
        handle: product.handle || '',
        productId: product.id || '',
        query: '',
        source: 'recent_product',
        term: product.title || '',
        title: product.title || '',
        url: product.url || '',
        userAction: BOOST_USER_ACTION_VIEW_PRODUCT
      };
      html += '<li class="mso-results__item mso-results__item--recent-product">' +
        '<a href="' + this._escapeAttr(product.url) + '" class="mso-results__recent-product-link" data-mso-analytics="' + this._escapeAttr(JSON.stringify(recentProductAnalytics)) + '">';
      if (product.image) {
        html += '<img class="mso-results__recent-product-img" src="' + this._escapeAttr(product.image) + '" alt="' + this._escapeAttr(product.title) + '" width="44" height="44" loading="lazy">';
      } else {
        html += '<span class="mso-results__recent-product-img mso-results__recent-product-img--placeholder" aria-hidden="true"></span>';
      }
      html += '<span class="mso-results__recent-product-title">' + this._escapeHtml(product.title) + '</span>' +
        '</a>' +
        '</li>';
    }

    html += '</ul></div></section>';
    return html;
  };

  MobileSearchOverlayController.prototype._renderRecentCollections = function () {
    var collections = this._getRecentCollections(false);
    if (!collections.length) return '';

    var html = '<section class="mso-results__section mso-results__section--recent-collections" aria-label="Recent collections">' +
      '<div class="mso-results__section-title">Recent collections</div>' +
      '<div class="mso-results__section-body">' +
      '<ul class="mso-results__list" role="list">';

    for (var i = 0; i < collections.length; i++) {
      var collection = collections[i];
      var recentCollectionAnalytics = {
        action: BOOST_ACTION_SEARCH,
        destinationType: 'collection',
        handle: collection.handle || '',
        query: '',
        source: 'recent_collection',
        term: collection.title || '',
        title: collection.title || '',
        url: collection.url || '',
        userAction: OVERLAY_USER_ACTION_VIEW_COLLECTION
      };
      html += '<li class="mso-results__item mso-results__item--recent-collection">' +
        '<a href="' + this._escapeAttr(collection.url) + '" class="mso-results__recent-collection-link" data-mso-analytics="' + this._escapeAttr(JSON.stringify(recentCollectionAnalytics)) + '">' +
        '<span>' + this._escapeHtml(collection.title) + '</span>' +
        '</a>' +
        '</li>';
    }

    html += '</ul></div></section>';
    return html;
  };

  MobileSearchOverlayController.prototype._showRecentSearches = function () {
    this._pendingRequestId++;
    clearTimeout(this._fetchTimeoutTimer);

    if (!this.results) return;
    var html = this._renderRecentSearches() +
      this._renderRecentProducts() +
      this._renderRecentCollections();
    if (!html) {
      this.results.innerHTML = '';
      this.results.setAttribute('hidden', '');
      return;
    }

    this.results.innerHTML = html;
    this.results.removeAttribute('hidden');
  };

  MobileSearchOverlayController.prototype._renderResults = function (suggestions, collections, products, q, dym) {
    if (!this.results) return;
    var html = '';
    var searchUrl = '/search?q=' + encodeURIComponent(q);

    // --- Did you mean row ---
    if (dym.length) {
      var dymHtml = '';
      for (var d = 0; d < dym.length; d++) {
        var term = String(dym[d] || '').trim();
        if (!term) continue;
        var dymAnalytics = {
          action: BOOST_ACTION_SUGGEST,
          destinationType: 'search',
          query: term,
          source: 'did_you_mean',
          term: term,
          title: term,
          url: '/search?q=' + encodeURIComponent(term),
          userAction: OVERLAY_USER_ACTION_VIEW_SEARCH_RESULTS
        };
        if (dymHtml) {
          dymHtml += '<span class="mso-results__dym-sep" aria-hidden="true">/</span>';
        }
        dymHtml += '<a href="/search?q=' + encodeURIComponent(term) + '" class="mso-results__dym-link" data-mso-save-search="' + this._escapeAttr(term) + '" data-mso-analytics="' + this._escapeAttr(JSON.stringify(dymAnalytics)) + '">' +
          this._escapeHtml(term) +
          '</a>';
      }

      if (dymHtml) {
        html += '<div class="mso-results__dym" aria-label="Did you mean">' +
          '<p class="mso-results__dym-text">Did you mean: ' + dymHtml + '</p>' +
          '</div>';
      }
    }

    // --- Suggestions section ---
    if (suggestions.length) {
      var suggestionsHtml = '';
      for (var i = 0; i < suggestions.length && i < SUGGESTION_LIMIT; i++) {
        var sug = suggestions[i];
        var text = (sug && (sug.text || sug.query || sug.value || ''));
        if (!text) continue;
        var sugUrl = '/search?q=' + encodeURIComponent(text);
        var suggestionAnalytics = {
          action: BOOST_ACTION_SUGGEST,
          destinationType: 'search',
          query: text,
          source: 'suggestion',
          term: text,
          title: text,
          url: sugUrl,
          userAction: OVERLAY_USER_ACTION_VIEW_SEARCH_RESULTS
        };
        suggestionsHtml += '<li class="mso-results__item mso-results__item--suggestion">' +
          '<a href="' + sugUrl + '" class="mso-results__suggestion-link" data-mso-save-search="' + this._escapeAttr(text) + '" data-mso-analytics="' + this._escapeAttr(JSON.stringify(suggestionAnalytics)) + '">' +
          '<svg class="mso-results__suggestion-icon" aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 18 19" fill="none">' +
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M11.03 11.68A5.784 5.784 0 112.85 3.5a5.784 5.784 0 018.18 8.18zm.26 1.12a6.78 6.78 0 11.72-.7l5.4 5.4a.5.5 0 11-.71.7l-5.41-5.4z" fill="currentColor"/>' +
          '</svg>' +
          '<span>' + this._escapeHtml(text) + '</span>' +
          '</a>' +
          '</li>';
      }
      if (suggestionsHtml) {
        html += '<section class="mso-results__section mso-results__section--suggestions" aria-label="Suggestions">' +
          '<div class="mso-results__section-title">Suggestions</div>' +
          '<div class="mso-results__section-body">' +
          '<ul class="mso-results__list" role="list">' +
          suggestionsHtml +
          '</ul>' +
          '</div>' +
          '</section>';
      }
    }

    // --- Collections section ---
    if (collections.length) {
      var collectionsHtml = '';
      for (var c = 0; c < collections.length && c < COLLECTION_LIMIT; c++) {
        var collection = collections[c];
        if (!collection || !collection.title || !collection.handle) continue;

        var collectionUrl = '/collections/' + collection.handle;
        var collectionSnapshot = {
          handle: collection.handle,
          title: collection.title,
          url: collectionUrl
        };
        var collectionAnalytics = {
          action: BOOST_ACTION_SUGGEST,
          destinationType: 'collection',
          handle: collection.handle,
          query: q,
          source: 'collection_suggestion',
          term: collection.title,
          title: collection.title,
          url: collectionUrl,
          userAction: OVERLAY_USER_ACTION_VIEW_COLLECTION
        };
        collectionsHtml += '<li class="mso-results__item mso-results__item--collection">' +
          '<a href="' + collectionUrl + '" class="mso-results__collection-link" data-mso-recent-collection="' + this._escapeAttr(JSON.stringify(collectionSnapshot)) + '" data-mso-analytics="' + this._escapeAttr(JSON.stringify(collectionAnalytics)) + '">' +
          '<span>' + this._escapeHtml(collection.title) + '</span>' +
          '</a>' +
          '</li>';
      }
      if (collectionsHtml) {
        html += '<section class="mso-results__section mso-results__section--collections" aria-label="Collections">' +
          '<div class="mso-results__section-title">Collections</div>' +
          '<div class="mso-results__section-body">' +
          '<ul class="mso-results__list" role="list">' +
          collectionsHtml +
          '</ul>' +
          '</div>' +
          '</section>';
      }
    }

    // --- Products section ---
    if (products.length) {
      var productsHtml = '';
      for (var j = 0; j < products.length && j < PRODUCT_LIMIT; j++) {
        var p = products[j];
        if (!p) continue;

        var title = p.title || '';
        var handle = p.handle || '';
        var productUrl = handle ? '/products/' + handle : searchUrl;

        // Image: Boost returns images_info array or images array
        var imgSrc = '';
        if (p.images_info && p.images_info.length && p.images_info[0].src) {
          imgSrc = p.images_info[0].src;
        } else if (p.images && p.images.length) {
          imgSrc = p.images[0];
        }
        // Use a small CDN size if it is a Shopify CDN URL
        if (imgSrc && imgSrc.indexOf('cdn.shopify.com') > -1) {
          imgSrc = imgSrc.replace(/(\.[^.?]+)(\?|$)/, '_100x100$1$2');
        }

        // Price: suppress for email-for-price and add-to-cart-for-price — mirrors
        // the hide-price behavior in base.css that applies to Boost's suggestion DOM.
        // The overlay uses different markup (mso-results__*) so we replicate the
        // rule here at render time rather than relying on base.css selectors.
        var tags = Array.isArray(p.tags) ? p.tags : [];
        var emailForPrice = tags.indexOf('product-status:email-for-price') > -1;
        var addToCartForPrice = tags.indexOf('product-status:add-to-cart-for-price') > -1;
        var suppressPrice = emailForPrice || addToCartForPrice;

        var priceHtml = '';
        if (!suppressPrice && typeof p.price_min === 'number') {
          var isOnSale = typeof p.compare_at_price_min === 'number' &&
                         p.compare_at_price_min > p.price_min;
          if (isOnSale) {
            priceHtml =
              '<p class="mso-results__product-price">' +
                '<s class="mso-results__product-compare-price">' +
                  this._escapeHtml(formatMoney(p.compare_at_price_min)) +
                '</s>&nbsp;' +
                '<span class="mso-results__product-sale-price">' +
                  this._escapeHtml(formatMoney(p.price_min)) +
                '</span>' +
              '</p>';
          } else {
            var priceStr = formatMoney(p.price_min);
            if (typeof p.price_max === 'number' && p.price_max !== p.price_min) {
              priceStr = 'From ' + priceStr;
            }
            priceHtml =
              '<p class="mso-results__product-price">' +
                '<span class="mso-results__product-regular-price">' +
                  this._escapeHtml(priceStr) +
                '</span>' +
              '</p>';
          }
        }

        var sku = (p.skus && p.skus.length && p.skus[0]) ? String(p.skus[0]) : '';
        var vendor = p.vendor ? String(p.vendor) : '';
        var productSnapshot = {
          id: p.id || '',
          handle: handle,
          title: title,
          url: productUrl,
          image: imgSrc,
          vendor: vendor,
          sku: sku
        };
        var productAnalytics = {
          action: BOOST_ACTION_SUGGEST,
          destinationType: 'product',
          handle: handle,
          productId: productSnapshot.id,
          query: q,
          source: 'product_suggestion',
          term: title,
          title: title,
          url: productUrl,
          userAction: BOOST_USER_ACTION_VIEW_PRODUCT
        };

        productsHtml += '<li class="mso-results__item mso-results__item--product">' +
          '<a href="' + productUrl + '" class="mso-results__product-link" data-mso-boost-product-id="' + this._escapeAttr(productSnapshot.id) + '" data-mso-recent-product="' + this._escapeAttr(JSON.stringify(productSnapshot)) + '" data-mso-analytics="' + this._escapeAttr(JSON.stringify(productAnalytics)) + '">';

        if (imgSrc) {
          productsHtml += '<img class="mso-results__product-img" src="' + this._escapeAttr(imgSrc) + '" ' +
            'alt="' + this._escapeAttr(title) + '" ' +
            'width="56" height="56" loading="lazy">';
        } else {
          productsHtml += '<span class="mso-results__product-img mso-results__product-img--placeholder" aria-hidden="true"></span>';
        }

        productsHtml += '<div class="mso-results__product-info">' +
          '<span class="mso-results__product-title">' + this._escapeHtml(title) + '</span>';
        if (sku) {
          productsHtml += '<span class="mso-results__product-sku">SKU: ' + this._escapeHtml(sku) + '</span>';
        }
        if (vendor) {
          productsHtml += '<span class="mso-results__product-vendor">' + this._escapeHtml(vendor) + '</span>';
        }
        if (priceHtml) {
          productsHtml += priceHtml;
        }
        productsHtml += '</div>';

        productsHtml += '</a></li>';
      }
      if (productsHtml) {
        html += '<section class="mso-results__section mso-results__section--products" aria-label="Products">' +
          '<div class="mso-results__section-title">Products</div>' +
          '<div class="mso-results__section-body">' +
          '<ul class="mso-results__list" role="list">' +
          productsHtml +
          '</ul>' +
          '</div>' +
          '</section>';
      }
    }

    // --- Footer ---
    var viewAllAnalytics = {
      action: BOOST_ACTION_SUGGEST,
      destinationType: 'search',
      query: q,
      source: 'view_all',
      term: q,
      title: q,
      url: searchUrl + '&type=product',
      userAction: OVERLAY_USER_ACTION_VIEW_SEARCH_RESULTS
    };
    html += '<div class="mso-results__footer">' +
      '<a href="' + searchUrl + '&type=product" class="mso-results__view-all" data-mso-save-search="' + this._escapeAttr(q) + '" data-mso-analytics="' + this._escapeAttr(JSON.stringify(viewAllAnalytics)) + '">' +
      'View all results for \u201c' + this._escapeHtml(q) + '\u201d' +
      '</a>' +
      '</div>';

    this.results.innerHTML = html;
    this.results.removeAttribute('hidden');
  };

  MobileSearchOverlayController.prototype._escapeHtml = function (str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  MobileSearchOverlayController.prototype._escapeAttr = function (str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  // --- Open / Close ---

  MobileSearchOverlayController.prototype.open = function (query) {
    var _isAppMode = document.documentElement.classList.contains('is-mobiloud-app');
    if ((!isMobile() && !_isAppMode) || !this.overlay) return;
    if (this._isOpen) return;

    this._closeCompetingUI();

    this._isOpen = true;

    // Remove the HTML hidden attribute before any class/style change.
    // hidden sets display:none at the attribute level; browsers may skip transitions
    // when transitioning from display:none in the same frame, so we remove it here
    // and defer the open class + aria change to rAF so the slide-in always runs.
    this.overlay.removeAttribute('hidden');

    // Restore saved query or use provided query (before rAF so value is ready on focus)
    var saved = (typeof query === 'string' ? query : null) || sessionStorage.getItem(SESSION_KEY) || '';
    if (saved) {
      this.input.value = saved;
    }
    this._syncHeaderControls();

    var self = this;
    window.requestAnimationFrame(function () {
      self.overlay.classList.add(OPEN_CLASS);
      self.overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add(BODY_OPEN_CLASS);
      if (self.scroller) self.scroller.classList.add('overflow-lock');

      if (document.documentElement.classList.contains('is-mobiloud-app')) {
        self._startViewportTracking();
      }
      self._syncHeaderControls();
      if (!document.documentElement.classList.contains('is-mobiloud-app')) {
        self.input.focus();
      }
      // If there is a saved query, trigger a fetch immediately
      if (saved && saved.trim().length >= MIN_QUERY_LENGTH) {
        self._fetchSuggestions(saved.trim());
      } else {
        self._showRecentSearches();
      }
    });

    document.addEventListener('keydown', this._boundOnKeydown);

    window.dispatchEvent(new CustomEvent('mobile-search:open', {
      detail: { query: this.input.value }
    }));
  };

  MobileSearchOverlayController.prototype.close = function () {
    if (!this._isOpen || !this.overlay) return;

    this._stopViewportTracking();
    var q = this.input.value || '';
    this._saveActiveQuery(q);

    // Cancel any in-flight request
    this._pendingRequestId++;
    clearTimeout(this._debounceTimer);
    clearTimeout(this._fetchTimeoutTimer);

    this._isOpen = false;
    this.overlay.classList.remove(OPEN_CLASS);
    this.overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(BODY_OPEN_CLASS);
    if (this.scroller) this.scroller.classList.remove('overflow-lock');

    // Clear results on close — they refetch when the user types on next open
    this._clearResults();

    document.removeEventListener('keydown', this._boundOnKeydown);

    if (this._activeTrigger) {
      var trigger = this._activeTrigger;
      window.requestAnimationFrame(function () { trigger.focus(); });
    }

    window.dispatchEvent(new CustomEvent('mobile-search:close', {
      detail: { query: q }
    }));
  };

  MobileSearchOverlayController.prototype._closeImmediate = function () {
    this._stopViewportTracking();
    this._isOpen = false;
    if (this.overlay) {
      // Restore the hidden attribute so display:none takes effect immediately,
      // bypassing the 250ms visibility transition delay in the CSS.
      this.overlay.setAttribute('hidden', '');
      this.overlay.classList.remove(OPEN_CLASS);
      this.overlay.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove(BODY_OPEN_CLASS);
    if (this.scroller) this.scroller.classList.remove('overflow-lock');
    document.removeEventListener('keydown', this._boundOnKeydown);
    this._clearResults();
  };

  MobileSearchOverlayController.prototype.setQuery = function (q) {
    if (!this.input) return;
    this.input.value = q;
    this._syncHeaderControls();
    // Trigger our debounced fetch
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
  };

  MobileSearchOverlayController.prototype.getQuery = function () {
    return (this.input ? this.input.value : '') || '';
  };

  MobileSearchOverlayController.prototype.setActiveTrigger = function (trigger) {
    if (!trigger || !trigger.nodeType) return;
    this._activeTrigger = trigger;
  };

  MobileSearchOverlayController.prototype.openFromTrigger = function (query, trigger) {
    this.setActiveTrigger(trigger);
    this.open(query);
  };

  MobileSearchOverlayController.prototype.toggle = function (query, trigger) {
    this.setActiveTrigger(trigger);

    if (this._isOpen) {
      this.close();
      return;
    }

    this.open(query);
  };

  MobileSearchOverlayController.prototype.isOpen = function () {
    return this._isOpen;
  };

  MobileSearchOverlayController.prototype._onKeydown = function (e) {
    if ((e.code || e.key || '').toUpperCase() === 'ESCAPE') {
      e.preventDefault();
      this.close();
    }
  };

  MobileSearchOverlayController.prototype._closeCompetingUI = function () {
    if (window.MobileMenuController && typeof window.MobileMenuController.close === 'function') {
      window.MobileMenuController.close();
    }
    var mobileMenuRoot = document.querySelector('[data-mobile-menu-root]');
    if (mobileMenuRoot && mobileMenuRoot.getAttribute('aria-hidden') === 'false') {
      var closeBtn = mobileMenuRoot.querySelector('[data-mobile-menu-close]');
      if (closeBtn) closeBtn.click();
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.classList.contains('active') && typeof cartDrawer.close === 'function') {
      cartDrawer.close();
    }

    var searchDetails = document.querySelector('.search-details[open]');
    if (searchDetails) searchDetails.removeAttribute('open');

    document.querySelectorAll('.dropdown-menu.show').forEach(function (menu) {
      menu.classList.remove('show');
    });
    document.querySelectorAll('.dropdown.show').forEach(function (dd) {
      dd.classList.remove('show');
    });
  };

  // --- iOS visual-viewport keyboard tracking (app mode only) ---

  MobileSearchOverlayController.prototype._startViewportTracking = function () {
    if (!window.visualViewport || !this.overlay) return;
    var self = this;
    this._onViewportResize = function () {
      if (!self._isOpen || !self.overlay) return;
      var keyboardOffset = window.innerHeight - window.visualViewport.height;
      /* Use paddingBottom, not bottom. The overlay is position:fixed; inset:0 with
         background:#fff — it always paints the full fixed viewport. Reducing `bottom`
         shrinks the painted area and races the keyboard animation, briefly exposing
         the page behind (the flicker). Padding shrinks only the flex content area
         inside the already-painted background, so the page is never exposed. */
      self.overlay.style.paddingBottom = keyboardOffset > 0 ? keyboardOffset + 'px' : '';
    };
    window.visualViewport.addEventListener('resize', this._onViewportResize);
    this._onViewportResize();
  };

  MobileSearchOverlayController.prototype._stopViewportTracking = function () {
    if (!window.visualViewport || !this._onViewportResize) return;
    window.visualViewport.removeEventListener('resize', this._onViewportResize);
    this._onViewportResize = null;
    if (this.overlay) this.overlay.style.paddingBottom = '';
  };

  // --- Initialization ---

  function init() {
    var controller = new MobileSearchOverlayController();

    window.MobileSearchOverlay = {
      open: function (query) { controller.open(query); },
      openFromTrigger: function (query, trigger) { controller.openFromTrigger(query, trigger); },
      close: function () { controller.close(); },
      toggle: function (query, trigger) { controller.toggle(query, trigger); },
      setActiveTrigger: function (trigger) { controller.setActiveTrigger(trigger); },
      setQuery: function (q) { controller.setQuery(q); },
      getQuery: function () { return controller.getQuery(); },
      isOpen: function () { return controller.isOpen(); }
    };

    // Before the browser freezes this page into bfcache, close any open overlay
    // so the snapshot is already in the closed state. Prevents the 250ms
    // visibility-transition flash that would occur if cleanup ran on pageshow.
    window.addEventListener('pagehide', function (event) {
      if (!event.persisted) return;
      if (controller._isOpen) {
        controller._closeImmediate();
      }
    });

    // Safety net: if the browser restores from bfcache without honouring the
    // pagehide cleanup, or if the DOM is visually open but _isOpen is false
    // (open() was mid-rAF when frozen), force-reset here too.
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      var domOpen = controller.overlay && (
        !controller.overlay.hasAttribute('hidden') ||
        controller.overlay.classList.contains(OPEN_CLASS)
      );
      if (controller._isOpen || domOpen) {
        controller._closeImmediate();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
